/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageEarthquakeStatusPage
 */
define(['module',
        'dojo',
        'dojo/dom-class',
        'dojo/_base/declare',
        'dojo/_base/lang',
        'dojo/text!./templates/SignageEarthquakeStatusPage.html',
        'idis/map/IdisMap',
        'idis/service/Requester',
        '../_SignageBase',
        'app/config',
        'idis/control/Locator',
        'dojo/dom-construct',
        'idis/view/dialog/DialogChain',
        'idis/view/Loader',
        'dojo/_base/array',
        'idis/consts/QUERY',
        // 以下、変数で受けないモジュール
        'dijit/Dialog',
        'dijit/form/Form',
        'dijit/layout/BorderContainer',
        'dijit/layout/ContentPane',
        'idis/view/form/AclButton',
], function(module, dojo, domClass, declare, lang, template, IdisMap, Requester, _SignageBase,
    config, Locator, domConstruct, DialogChain, Loader, array, QUERY) {

        // 前回表示データ
        // セッションストレージ等に保持するほうが良いか？
        var prevItemStore = {};

        /**
         *
         * @class SignageEarthquakeStatusPage
         * @extends module:idis/view/page/_PageBase~_PageBase
         */
        return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageEarthquakeStatusPage~SignageEarthquakeStatusPage# */
        {
            // テンプレート文字列
            templateString: template,

            store: null,

            _timer: null,

            // レイヤーID
            _layerId: [],

            // 緯度経度
            _latlng: null,

            // ズーム
            _zoom: 9,

            _layerControl: null,

            // 更新時間（秒）
            SIGNAGE_UPDATE_INTERVAL: 10,

            // 値を表示する項目のリスト
            target: [
                {'item':'prefMaxint', 'area':'prefMaxintArea'},
                {'item':'magnitude', 'area':'magnitudeArea'},
                {'item':'originTime', 'area':'originTimeArea'},
                {'item':'hypocenyterName', 'area':'hypocenyterNameArea'}
            ],

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function() {
                this.inherited(arguments);
                this.chain = DialogChain.get(this);
            },

            buildRendering: function() {
                this.inherited(arguments);
            },

            startup: function() {
                this.inherited(arguments);
                // this.initPage();
                this.setEarthquakeAndTsunamiInfo();
            },

            destroy: function() {
                this.inherited(arguments);
                clearTimeout(this._timer);
            },
    
            /**
             * 画面表示
             */
            initPage: function(itemList) {

                Requester.get('/api/signage/' + this._screenId).then(lang.hitch(this,function(data) {
                    var item = data;
                    this._version = item.version;
                    // レイヤー
                    this._layerId = item.layerId;
                    // 緯度経度
                    if (item.latitude && item.longitude) {
                        this._latlng = [item.latitude, item.longitude];
                    } else if (this._zoom === 7) {
                        this._latlng = [config.map.latitude, config.map.longitude];
                    } else if (itemList.items[0].latitude !== null && this._zoom === 9) {
                        this._latlng = [itemList.items[0].latitude, itemList.items[0].longitude];
                    } else {
                        this._latlng = [config.map.latitude, config.map.longitude];
                    }
                    // ズーム ズームサイズが７と９を交互に表示する
                    if (item.zoom) {
                        this._zoom = item.zoom;
                    } else if (this._zoom === 9) {
                        this._zoom = 7;
                        
                    } else if (this._zoom === 7) {
                        this._zoom = 9;
                    } else {
                        this._zoom = 9;
                    }
    
                    // マップを初期化
                    this.initMap(this._zoom);
                    this.putFirstLayer();

                    // レイヤーを表示
                    this.showLayer();
    
                }), function(error) {
                    // 処理失敗時はエラーログを出力し、エラーダイアログを表示
                    console.error(error);
                    this.chain.infoError(error);
                });

                // 定期更新処理
                this._timer = setTimeout(lang.hitch(this, function() {
                    this.initPage(itemList);
                }), this.SIGNAGE_UPDATE_INTERVAL * 1000);
            },

            initMap: function () {

                // マップの初期化
                if (this.map !== undefined && this.map !== null)
                {
                    this.map.remove();
                }
                this.map = new IdisMap(this.id + '-map', {
                    config: config.map,
                    keyboard: false, // コメント時に+/-が使用できないため
                    touchExtend: false, // IE対応
                    minZoom: 7,
                    maxZoom: 10,
                    drawControlTooltips: false
                }).setView(this._latlng, this._zoom);

                // mapのdestroyはremoveでDojoと互換なのでownで消せる
                this.own(this.map);

                this._layerControl = this.map.layerControl;

                
            },

            /**
             * 地震・津波情報を設定する
             */
            setEarthquakeAndTsunamiInfo: function() {
                var promise = Requester.get('/data/signage/' + this._screenId +'.json', {
                    headers: {'Content-Type': 'application/json; charset=utf-8'},
                    handleAs: 'json',
                    preventCache : true
                }).then(lang.hitch(this, function (item) {

                    // 地図を設定
                    this.initPage(item);

                    // 地震情報を設定
                    var earthquakeList = item.items.filter(function(element) {
                        return element.foKindCode === null;
                    });
                    this.setEarthquake(this, earthquakeList);
                    // 津波情報を設定
                    var tsunamiList = item.items.filter(function(element) {
                        return element.foKindCode !== null;
                    });
                    this.setTsunami(this, tsunamiList);
                    // 前回データを更新
                    prevItemStore[this._screenId] = item;

                }), function (error) {
                    if (error.response.status === 404) {
                        var earthquakeList = [];
                        this.setEarthquake(this, earthquakeList);
                        var tsunamiList = [];
                        this.setTsunami(this, tsunamiList);
                    } else {
                        this.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * 地震情報(県内最大震度)を表示する
             */
            setEarthquake: function(self, item) {
                if (item[0] !== undefined) {
                    if (item[0].prefMaxint !== null) {
                        array.forEach(this.target, function(target){
                            self[target.item].innerHTML = item[0][target.item];
                        });
                        this.setEarthquakeUpdate(this, item);
                    }
                }
            },

            /**
             * 画面上部エリアの更新状態を設定します
             */
            setEarthquakeUpdate: function(self, item) {
                var updateFlg = false;
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevItemStore[this._screenId];
                if (!prevItem || !item) {
                    return;
                }
                var earthquakeInfo = prevItem.items[0];
                if (earthquakeInfo) {
                    array.forEach(this.target, function(target){
                        // 更新された項目にstyleを設定
                        if (earthquakeInfo[target.item] !== item[0][target.item]) {
                            domClass.add(self[target.area], 'update-column');
                            updateFlg = true;
                        } else {
                            domClass.remove(self[target.area], 'update-column');
                        }
                    });
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            /**
             * 津波情報を表示する
             */
            setTsunami: function(self, data) {
                var earthquakeTBody = dojo.byId('earthquakeTBody');
                domConstruct.empty(earthquakeTBody);
                var tr = domConstruct.create('tr');
                var bgcolor = '';
                var fontsize = '';
                var fontcolor = '';
                var tsunamiType = '発表なし';
                var tsunamiInfo = '';
                var tyuihoFlg = 0;
                var keihoFlg = 0;
                var ohkeihoFlg = 0;
                var totalKeihoType = 0;

                // 表示件数に合わせてフォントサイズを変更する
                array.forEach(data, function(item){
                    if (item.foKindCode === '62' && tyuihoFlg === 0) {
                        tyuihoFlg = 1;
                    } else if ((item.foKindCode === '52' || item.foKindCode === '53') && keihoFlg === 0) {
                        keihoFlg = 1;
                    } else if (item.foKindCode === '51' && ohkeihoFlg === 0) {
                        ohkeihoFlg = 1;
                    };
                });
                totalKeihoType = tyuihoFlg+ keihoFlg + ohkeihoFlg;

                switch(totalKeihoType) {
                    case 0:
                    case 1:
                        fontsize = 'fs-2';
                        break;
                    case 2:
                        fontsize = 'fs-4';
                        break;
                    case 3:
                        fontsize = 'fs-6';
                        break;
                }

                tyuihoFlg = 0;
                keihoFlg = 0;
                ohkeihoFlg = 0;

                var prevItem = prevItemStore[this._screenId];
                var tsunamiPrevList = [];
                if (prevItem) {
                    tsunamiPrevList = prevItem.items.filter(function(element) {
                        return element.foKindCode !== null;
                    });
                }
                var updateFlg = false;
                var className = '';
                // 津波の前回値
                var tsunamiPrevItem = null;

                // 津波情報を表示する
                if (data.length > 0) {
                    array.forEach(data, function(item){

                        if (prevItem && prevItem.items.length > 0) {
                            tsunamiPrevItem = tsunamiPrevList.filter((element) =>
                                element.foKindCode === item.foKindCode
                            )[0];
                            // 新規のデータが追加された場合は前回値を0として設定
                            if (tsunamiPrevItem === undefined) {
                                tsunamiPrevItem = {"foKindCode": 0};
                            }
                        }
                        className = tsunamiPrevItem && (tsunamiPrevItem.foKindCode !== item.foKindCode) ? ' update-column' : '';
                        if (className) { updateFlg = true; };
    
                        if (item.foKindCode === '62' && tyuihoFlg === 0) {
                            bgcolor = '#FAF500';// 黄色
                            fontcolor = 'black';
                            tsunamiType = '津波注意報発表';
                            tsunamiInfo = '<span class="' + fontsize + className + '" style="padding: 10px 20px; margin: 0 15px 0 0; background-color: ' + bgcolor + '; color: ' + fontcolor + ';">' + tsunamiType + '</span>';
                            tyuihoFlg = 1;
                        } else if ((item.foKindCode === '52' || item.foKindCode === '53') && keihoFlg === 0) {
                            bgcolor = '#C800FF';// 紫色
                            fontcolor = '#FFFFFF';
                            tsunamiType = '大津波警報発表';
                            tsunamiInfo = '<span class="' + fontsize + className + '" style="padding: 10px 20px; margin: 0 15px 0 0; background-color: ' + bgcolor + '; color: ' + fontcolor + ';">' + tsunamiType + '</span>';
                            keihoFlg = 1;
                        } else if (item.foKindCode === '51' && ohkeihoFlg === 0) {
                            bgcolor = '#FF2800';// 赤色
                            fontcolor = '#FFFFFF';
                            tsunamiType = '津波警報発表';
                            tsunamiInfo = '<span class="' + fontsize + className + '" style="padding: 10px 20px; margin: 0 15px 0 0; background-color: ' + bgcolor + '; color: ' + fontcolor + ';">' + tsunamiType + '</span>';
                            ohkeihoFlg = 1;
                        };
                        domConstruct.place(domConstruct.create('td', {innerHTML: tsunamiInfo, class: 'tsunami'}), tr);
                        domConstruct.place(tr, earthquakeTBody);
                    });
                } else {
                    if (tsunamiPrevList && tsunamiPrevList.length > 0) {
                        tsunamiPrevItem = tsunamiPrevList.filter((element) =>
                            element.foKindCode !== null
                        )[0];
                    }
                    className = tsunamiPrevItem ? ' update-column' : '';
                    if (className) { updateFlg = true; };
                    tsunamiInfo = '<span class="' + fontsize + className + '" style="padding: 10px 20px; margin: 0 15px 0 0;">' + tsunamiType + '</span>';
                    domConstruct.place(domConstruct.create('td', {innerHTML: tsunamiInfo}), tr);
                    domConstruct.place(tr, earthquakeTBody);
                }

                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            /**
             * レイヤー表示
             */
            showLayer: function () {
                // 指定したレイヤーを表示
                var layerQuery = Locator.getLayerQuery();

                var earthquakeLayerId = 59;// 地震のレイヤーIDを設定
                var tsunamiLayerId = 60;// 津波のレイヤーIDを設定
                layerQuery[earthquakeLayerId] = layerQuery[earthquakeLayerId] || '0';
                layerQuery[tsunamiLayerId] = layerQuery[tsunamiLayerId] || '0';

                // URLに反映
                Locator.replaceState(QUERY.LAYER_LIST, Locator.toLayerQuery(layerQuery));
            }
        });
    });
